var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78949 2.71734L16.7895 5.82734V10.5273C16.7895 15.0473 13.8095 19.2173 9.78949 20.4573C5.76949 19.2173 2.78949 15.0473 2.78949 10.5273V5.82734L9.78949 2.71734ZM9.78949 0.527344L0.78949 4.52734V10.5273C0.78949 16.0773 4.62949 21.2673 9.78949 22.5273C14.9495 21.2673 18.7895 16.0773 18.7895 10.5273V4.52734L9.78949 0.527344ZM8.78949 6.52734H10.7895V8.52734H8.78949V6.52734ZM8.78949 10.5273H10.7895V16.5273H8.78949V10.5273Z",
    fill: "#0F0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.4a24f40c1b74ab93140e0bf85a9195de.svg";
export { ForwardRef as ReactComponent };